import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const WhyTno = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          border: `2px solid ${theme.palette.primary.main}`,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          maxWidth: 720,
          mx: 'auto',
        }}
      >
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Por qué TNO Network para Daka
        </Typography>
        <Typography variant="h6" align="center" fontWeight={700} paragraph>
          Daka vende tecnología y TNO es tecnología.
        </Typography>
        <Typography variant="body1" color="textSecondary" align="center" paragraph>
          El mensaje <strong>Sé feliz</strong> de Daka encuentra en TNO la plataforma ideal para llegar a quien
          busca soluciones reales. Esta alianza no es solo publicidad: son activos digitales (artículos SEO) que
          perduran y siguen generando ventas mucho después de su publicación.
        </Typography>
      </Box>
    </Box>
  );
};

export default WhyTno;
